import { maskDate } from 'utils/mask';

export const dadosFormatados = (ocorrencias: any) => {
  const data = ocorrencias.map((item: any) => {
    let status;
    switch (item.status) {
      case 'AA':
        status = 'Aguardando atendimento';
        break;
      case 'EA':
        status = 'Em atendimento';
        break;
      case 'AC':
        status = 'Atendimento finalizado';
        break;
      default:
        status = '';
        break;
    }
    return {
      Protocolo: item.protocolo,
      'Tipo de solicitação': item.tipoSolicitacao,
      'Classificação de urgência': item.urgencia,
      Status: status,
      Parceiro: item.parceiro,
      'N° da(s) nota(s)': item.listaNf,
      'Data da abertura': maskDate(item.dtAbertura),
      'Data da conclusão': maskDate(item.dtConclusao),
      Assunto: item.assunto,
      Embarcador: item.embarcador,
      Atendente: item.atendente,
    };
  });

  return data;
};
